import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/ucet" as const,
	[Locale.en]: "/account" as const,
} satisfies LocalizedString;

export function getAccountDetailsPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
